<template>
  <div class="fablic-composition">
    <v-row class="align-center">
      <v-col cols="7">
        Compositions
      </v-col>
      <v-col cols="2"></v-col> <v-col
        v-for="(composition, index) in fabricCompositions"
        :key="index"
        cols="12"
      >
        <v-row>
          <v-col cols="7">
            <v-select
              v-model="composition.name"
              outlined
              :rules="ruleActive ? fabricNameRules : []"
              clearable
              dense
              :items="masterCompositions"
              label="Composition"
            ></v-select>
          </v-col>
          <v-col
            class="d-flex"
            cols="3"
          >
            <v-text-field
              v-model.number="composition.percentage"
              type="number"
              label="Percentage"
              :rules="ruleActive ? percentageRules : []"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              class="text-center"
              color="red"
              icon
              :disabled="fabricCompositions.length === 1"
              @click="removeMaterial(index)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-btn
          small
          :disabled="totalPercentage >= 100"
          @click="addMaterial"
        >
          Add Composition
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-alert
          v-if="totalPercentage !== 100 && fabricCompositions.length > 0"
          type="warning"
          outlined
          class="mt-4"
        >
          Total percentage must be 100%. Current total: {{ totalPercentage }}%
        </v-alert>
        <v-alert
          v-if="totalPercentage === 100 && fabricCompositions.length > 0"
          type="success"
          outlined
          class="mt-4"
        >
          Total percentage is 100%!
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

  <script>
  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        fabricCompositions: [{ name: '', percentage: 0 }],
        percentageRules: [
          (v) => (v !== null && v !== undefined && v !== '') || 'Percentage is required',
          (v) => v >= 0 || 'Percentage cannot be negative',
          () => this.totalPercentage === 100
        ],
        fabricNameRules: [
          (v) => !!v || 'Composition is required!',
          () => !this.hasDuplicateFabricNames || 'Composition are duplicated'
        ],
        masterCompositions: [
          'COTTON',
          'LINEN',
          'POLYESTER',
          'NYLON',
          'RAYON',
          'LYOCELL',
          'ACRYLIC',
          'SPANDEX',
          'WOOL',
          'SILK',
          'POLYURETHANE',
          'RAMIE',
          'VISCOSE',
          'METALLISED',
          'POLYPROPYLENE',
          'POLYVINYL CHLORIDE',
          'ACETATE',
          'ELASTIC',
          'TENCEL FIBER',
          'POLYAMIDE'
        ]
      }
    },
    computed: {
      totalPercentage () {
        return this.fabricCompositions.reduce((sum, composition) => sum + (Number(composition.percentage) || 0), 0)
      },
      hasDuplicateFabricNames () {
        const names = this.fabricCompositions.map((f) => f.name)
        const uniqueNames = new Set(names)
        return uniqueNames.size !== names.length
      },
      ruleActive () {
        return this.fabricCompositions.findIndex((fc) => fc.name || fc.percentage) !== -1 || this.fabricCompositions.length > 1
      }
    },
    watch: {
      value: {
        handler (val) {
          const newVal = Array.isArray(val) && val.length ? [...val] : [{ name: '', percentage: 0 }]
          if (JSON.stringify(newVal) !== JSON.stringify(this.fabricCompositions)) {
            this.fabricCompositions = newVal
          }
        },
        immediate: true,
        deep: true
      },
      fabricCompositions: {
        handler (val) {
          this.$emit('input', val)
        },
        deep: true
      }
    },
    methods: {
      addMaterial () {
        if (this.totalPercentage < 100) {
          this.fabricCompositions.push({ name: '', percentage: 0 })
        }
      },
      removeMaterial (index) {
        if (this.fabricCompositions.length > 1) {
          this.fabricCompositions.splice(index, 1)
        }
      }
    }
  }
  </script>

  <style scoped>
  .fablic-composition {
    padding: 16px;
    border: 1px solid #eee;
    border-radius: 4px;
  }
  </style>
